/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";

const Tarjeta_Variacion_Producto = ({item, click, index}) => {
    const [img, setImg] = useState('')


    const TituloTexto = ({titulo, texto}) => {
        return (
            <Grid
                onClick={() => click(item, index)}
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 12, fontWeight: 300, color: '#00000050'}}>{titulo}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>{texto}</Typography>
                </Grid>


            </Grid>
        )
    }

    useEffect(() => {
        if (typeof item.img === 'object') {
            setImg(URL.createObjectURL(item.img))
        } else {
            setImg(item.img)
        }
    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}

            sx={{borderBottom: 1, borderColor: '#00000050'}}
        >

            {img &&
                <Grid container size={2}>
                    <img src={img} width={'100%'}/>
                </Grid>
            }

            <Grid container size={3}>
                <TituloTexto titulo={'Nombre'} texto={item.nombre}/>
            </Grid>

            <Grid container size={3}>
                <TituloTexto titulo={'C. Existente'} texto={item.cantidad}/>
            </Grid>

            <Grid container size={3}>
                <TituloTexto titulo={'C. Minima'} texto={item.minimo}/>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Variacion_Producto